import React from 'react';
import { Typography, IconButton, Grid, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ExpenseComp } from 'types/underwriting/income-approach/expenses';

interface Props {
  item: ExpenseComp;
  index: number;
  deleteColumn: (compId: string) => void;
  isOutdated: boolean;
  disabled?: boolean;
}

const ColumnHeader: React.FC<Props> = ({ disabled, item, index, deleteColumn, isOutdated }) => {
  const label = `Comparable ${index + 1}`;
  const { key } = item;

  // TODO: do something with the isOutdated flag
  return (
    <Grid container direction="row" sx={{ alignItems: 'center' }}>
      <Grid item>
        <Typography
          variant="body2"
          sx={{
            fontWeight: 'bold',
          }}
        >
          {label}
        </Typography>
      </Grid>
      <Grid>
        {!disabled && (
          <IconButton sx={{ marginLeft: 1 }} onClick={() => deleteColumn(key)}>
            <Tooltip title="Delete">
              <CloseIcon />
            </Tooltip>
          </IconButton>
        )}
      </Grid>
    </Grid>
  );
};

export default React.memo(ColumnHeader);
